import { Grid2 as Grid, SelectChangeEvent } from '@mui/material';
import { useFormikContext } from 'formik';
import { getFixedT } from 'i18next';
import React, { useCallback, useContext, useMemo } from 'react';

import { EstateFilterSelectField } from '../../../../../components';
import { CatalogsContext } from '../../../../../context';
import { Room } from '../../../../../icons';

const t = getFixedT(null, 'core-immobilien');

const DEFAULT_ANY_VALUE = Number.MAX_VALUE;

interface Props {
  fieldName?: string;
}

export const RoomsFilter: React.FC<Props> = ({ fieldName = 'minNumberRooms' }) => {
  const { loading, roomsFrom } = useContext(CatalogsContext);
  const { values, errors, setFieldTouched, setFieldValue, handleBlur } = useFormikContext();

  const roomsItems = useMemo(() => {
    if (loading || !roomsFrom?.length) {
      return [];
    }
    return [
      { value: DEFAULT_ANY_VALUE, label: t('estateSearch.any') },
      ...roomsFrom.filter((item) => item.id > -1).map((item) => ({ value: item.id, label: item.code })),
    ];
  }, [loading, roomsFrom]);

  const handleChange = useCallback(
    (event: SelectChangeEvent<unknown>) => {
      const value = event.target.value as string | number;
      setFieldTouched(fieldName, true);
      setFieldValue(fieldName, value === DEFAULT_ANY_VALUE ? null : value, true);
    },
    [setFieldTouched, setFieldValue, fieldName]
  );

  const renderValue = useCallback(
    (value: string | number) => (value === '' || value === DEFAULT_ANY_VALUE ? t('estateSearch.any') : value),
    []
  );

  return (
    <Grid container spacing={3}>
      <Grid size={6}>
        <EstateFilterSelectField
          name="roomSearch"
          label={t('roomSearchPlaceholder')}
          value={values[fieldName] ?? DEFAULT_ANY_VALUE}
          renderValue={renderValue}
          items={roomsItems}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(errors[fieldName])}
          errorMessage={errors[fieldName] || ''}
          startAdornment={<Room />}
        />
      </Grid>
    </Grid>
  );
};

RoomsFilter.displayName = 'RoomsFilter';
